import { ColumnDef } from '@tanstack/react-table';

import { FlightTableRow } from './CampaignFlightsTable';
import { FlightsTableColumnId } from './FlightsTableColumnConfig';

/**
 * Default columns displayed in the flights table when user hasn't customized.
 * The 'actions' column is always shown (non-configurable) and is not in this list.
 */
export const defaultFlightsColumnsConfig: FlightsTableColumnId[] = [
  FlightsTableColumnId.StartDate,
  FlightsTableColumnId.Duration,
  FlightsTableColumnId.EventName,
  FlightsTableColumnId.EventDate,
  FlightsTableColumnId.PotentialRevenue,
  FlightsTableColumnId.Revenue,
  FlightsTableColumnId.Spend,
  FlightsTableColumnId.Roas,
  FlightsTableColumnId.PotentialSales,
  FlightsTableColumnId.SalesCount,
  FlightsTableColumnId.HistoricPotentialImpressions,
  FlightsTableColumnId.ActualImpressions,
  FlightsTableColumnId.ImpressionShare,
  FlightsTableColumnId.Clicks,
  FlightsTableColumnId.Cpc,
  FlightsTableColumnId.Budget,
  FlightsTableColumnId.BudgetRemaining,
  FlightsTableColumnId.Status,
  FlightsTableColumnId.Target,
];

/**
 * Minimal column definitions used by ColumnSettingsModal to power the column picker UI.
 * Each entry maps a column ID to a lightweight ColumnDef with just an `id`.
 * The actual column rendering is handled by getTableColumnDefinitions in CampaignFlightsTableColumnsConfig.
 */
export const FLIGHTS_TABLE_COLUMNS_SETTINGS_CONFIG: Partial<
  Record<FlightsTableColumnId, ColumnDef<FlightTableRow>>
> = {
  [FlightsTableColumnId.StartDate]: {
    id: FlightsTableColumnId.StartDate,
  },
  [FlightsTableColumnId.Duration]: {
    id: FlightsTableColumnId.Duration,
  },
  [FlightsTableColumnId.Campaign]: {
    id: FlightsTableColumnId.Campaign,
  },
  [FlightsTableColumnId.EventName]: {
    id: FlightsTableColumnId.EventName,
  },
  [FlightsTableColumnId.EventDate]: {
    id: FlightsTableColumnId.EventDate,
  },
  [FlightsTableColumnId.PotentialRevenue]: {
    id: FlightsTableColumnId.PotentialRevenue,
  },
  [FlightsTableColumnId.Revenue]: {
    id: FlightsTableColumnId.Revenue,
  },
  [FlightsTableColumnId.Spend]: {
    id: FlightsTableColumnId.Spend,
  },
  [FlightsTableColumnId.Roas]: {
    id: FlightsTableColumnId.Roas,
  },
  [FlightsTableColumnId.PotentialSales]: {
    id: FlightsTableColumnId.PotentialSales,
  },
  [FlightsTableColumnId.SalesCount]: {
    id: FlightsTableColumnId.SalesCount,
  },
  [FlightsTableColumnId.HistoricPotentialImpressions]: {
    id: FlightsTableColumnId.HistoricPotentialImpressions,
  },
  [FlightsTableColumnId.ActualImpressions]: {
    id: FlightsTableColumnId.ActualImpressions,
  },
  [FlightsTableColumnId.ImpressionShare]: {
    id: FlightsTableColumnId.ImpressionShare,
  },
  [FlightsTableColumnId.Clicks]: {
    id: FlightsTableColumnId.Clicks,
  },
  [FlightsTableColumnId.Cpc]: {
    id: FlightsTableColumnId.Cpc,
  },
  [FlightsTableColumnId.Budget]: {
    id: FlightsTableColumnId.Budget,
  },
  [FlightsTableColumnId.BudgetRemaining]: {
    id: FlightsTableColumnId.BudgetRemaining,
  },
  [FlightsTableColumnId.Status]: {
    id: FlightsTableColumnId.Status,
  },
  [FlightsTableColumnId.Target]: {
    id: FlightsTableColumnId.Target,
  },
  [FlightsTableColumnId.IncrementalSellerProceeds]: {
    id: FlightsTableColumnId.IncrementalSellerProceeds,
  },
  [FlightsTableColumnId.Actions]: {
    id: FlightsTableColumnId.Actions,
  },
};
